import React from 'react';
import { useTranslation } from '../lib/i18n';
export function ShippingPaymentPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <main className="min-h-screen bg-dark-bg pt-24 pb-16" data-id="element-1052">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1053">
        <h1 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-1054">
          {en ? 'Shipping & Payment Policy' : ru ? 'Политика доставки и оплаты' : 'Politika isporuke i plaćanja'}
        </h1>
        <div className="prose prose-invert max-w-none text-gray-300 space-y-6" data-id="element-1055">
          <p data-id="element-1056">
            Ova politika definiše uslove isporuke i načine plaćanja za proizvode
            kupljene preko kompanije DTECH ATLAS DOO.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1057">
            1. Načini plaćanja
          </h2>
          <p data-id="element-1058">
            Plaćanje se vrši isključivo preko računa (virmanski) na osnovu
            izdatog predračuna. Nakon što potvrdite porudžbinu, poslaćemo vam
            predračun sa svim potrebnim instrukcijama za uplatu. Roba se
            isporučuje ili poručuje iz proizvodnje tek nakon evidentirane
            uplate.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1059">
            2. Rokovi isporuke
          </h2>
          <p data-id="element-1060">Rok isporuke zavisi od dostupnosti proizvoda:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-1061">
            <li data-id="element-1062">
              <strong data-id="element-1063">Proizvodi na stanju:</strong> Isporuka se vrši u roku od 2
              do 5 radnih dana od evidentiranja uplate.
            </li>
            <li data-id="element-1064">
              <strong data-id="element-1065">Proizvodi koji se poručuju:</strong> Rok isporuke je
              obično 4 do 8 nedelja iz proizvodnje. Tačan rok biće definisan u
              ponudi/predračunu.
            </li>
          </ul>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1066">
            3. Način isporuke
          </h2>
          <p data-id="element-1067">
            Isporuka se vrši na teritoriji Republike Srbije putem kurirskih
            službi ili namenskom dostavom, u zavisnosti od gabarita i težine
            mašine. Troškovi isporuke padaju na teret kupca, osim ukoliko nije
            drugačije dogovoreno i navedeno u ponudi.
          </p>
          <p data-id="element-1068">
            <strong data-id="element-1069">Napomena:</strong> Nemamo izložbeni salon na adresi sedišta
            firme. Sve porudžbine i isporuke se vrše isključivo online ili
            namenskom dostavom.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-1070">
            4. Preuzimanje robe
          </h2>
          <p data-id="element-1071">
            Prilikom preuzimanja robe, kupac je dužan da vizuelno pregleda
            paket. Ukoliko primetite bilo kakva oštećenja na ambalaži, molimo
            vas da to odmah prijavite kuriru i kontaktirate nas.
          </p>
        </div>
      </div>
    </main>;
}